import * as React from 'react'
import { Input } from 'antd-v4'

interface Props {
  id?: any
  className?: any
  style?: any
  value: number | null
  addonAfter?: React.ReactNode
  onChange: (value: number | null) => void
  disabled?: boolean
}

interface State {
  stringValue: string
}

export class UncontrolledNumberInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      stringValue: '',
    }
  }

  componentDidMount() {
    this.setState({
      stringValue: this.props.value !== null ? this.props.value.toString() : '',
    })
  }

  change(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      stringValue: e.target.value.replace(/[^0-9.]/g, ''),
    })
    if (e.target.value === '') {
      return this.props.onChange(null)
    }
    const parsedValue = parseFloat(e.target.value)
    if (!isNaN(parsedValue)) {
      this.props.onChange(parsedValue)
    } else {
      // Not a number, don't send anything
    }
  }

  render() {
    return (
      <Input
        id={this.props.id}
        className={this.props.className}
        style={this.props.style}
        value={this.state.stringValue || ''}
        addonAfter={this.props.addonAfter}
        onChange={(e) => this.change(e)}
        disabled={this.props.disabled}
      />
    )
  }
}
